import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cashbox } from '@common/models/cashbox.model';
import { AnalyticsService, CashboxService, ToastService } from '@common/services';
import { UserService } from '@modules/auth/services';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import lottie from 'lottie-web';

@Component({
    selector: 'fina-cashbox-close',
    templateUrl: './cashbox-close.component.html',
    styleUrls: ['./cashbox-close.component.scss'],
})
export class CashboxCloseComponent implements OnInit {
    @Input() currentCashbox: Cashbox;
    @Input() isForcedClose: boolean = false;
    @Output() cashboxClosed = new EventEmitter<Cashbox>();
    @Output() modalClosed = new EventEmitter<void>();

    finalAmountUSD: number = 0;
    observaciones: string = '';
    step: 'amount' | 'observations' = 'amount';
    discrepancy: number = 0;
    hasDiscrepancy: boolean = false;
    loading: boolean = false;
    closedCashbox: Cashbox | null = null;
    daysOpen: number = 0;

    constructor(
        private activeModal: NgbActiveModal,
        private cashboxService: CashboxService,
        private toastService: ToastService,
        private modalService: NgbModal,
        private analyticsService: AnalyticsService,
        public userService: UserService,
    ) {}

    ngOnInit(): void {
        this.currentCashbox = this.cashboxService.currentCashbox;
        if (this.isForcedClose) {
            const openingDate = new Date(this.currentCashbox.openingDate);
            const today = new Date();
            this.daysOpen = Math.floor((today.getTime() - openingDate.getTime()) / (1000 * 60 * 60 * 24));
        }
    }

    getModalTitle(): string {
        if (this.isForcedClose) {
            return `Cierre de caja pendiente (${this.daysOpen} día${this.daysOpen > 1 ? 's' : ''})`;
        }
        return 'Cerrar caja';
    }

    getModalSubtitle(): string {
        if (this.isForcedClose) {
            return `La caja ha estado abierta por ${this.daysOpen} día${this.daysOpen > 1 ? 's' : ''}. ¿Deseas cerrar la caja?.`;
        }
        return 'Ingrese el monto final de cierre';
    }

    cancelClose() {
        if (this.isForcedClose) {
            const alertToast = this.toastService.alert('Atención', 'Se le volverá a solicitar el cierre de caja en su próximo inicio de sesión.');
            // Make the alert temporary by clearing it after 5 seconds
            setTimeout(() => {
                // Clear all toasts (this will remove the alert)
                this.toastService.toasts = [];
            }, 5000);
        }
        this.activeModal.dismiss('cancel');
    }

    proceedToObservations() {
        if (this.finalAmountUSD === undefined || this.finalAmountUSD === null) {
            this.toastService.error('Error', 'Por favor ingrese el monto final.');
            return;
        }

        this.loading = true;
        this.cashboxService.closeCashBox(this.finalAmountUSD).subscribe({
            next: closedCashbox => {
                this.analyticsService.analyticsCapture('cashbox_closed');
                this.closedCashbox = closedCashbox;
                this.discrepancy = closedCashbox.discrepancy;
                this.hasDiscrepancy = this.discrepancy !== 0;
                this.step = 'observations';
                this.loading = false;

                // Initialize confetti animation if there's no discrepancy
                if (!this.hasDiscrepancy) {
                    setTimeout(() => this.initializeAnimation(), 100);
                }
            },
            error: error => {
                console.error('Error closing cashbox:', error);
                this.toastService.error('Error', 'No se pudo cerrar la caja. Por favor intente nuevamente.');
                this.loading = false;
            },
        });
    }

    closeCashbox() {
        if (!this.closedCashbox) {
            console.error('No closed cashbox data available');
            return;
        }

        this.loading = true;
        this.cashboxService.addObservationsToCashbox(this.closedCashbox._id, this.observaciones).subscribe({
            next: updatedCashbox => {
                this.toastService.success('Cierre de caja completado', 'El cierre de caja se ha completado exitosamente.');
                this.cashboxClosed.emit(updatedCashbox);
                this.modalService.dismissAll();
                this.modalClosed.emit();
            },
            error: error => {
                console.error('Error adding observations:', error);
                this.toastService.error('Error', 'No se pudieron agregar las observaciones al cierre de caja.');
            },
            complete: () => {
                this.loading = false;
            },
        });
    }

    initializeAnimation() {
        console.log('Initializing animation...');
        const animationContainer = document.getElementById('animation-confetti');
        if (animationContainer) {
            console.log('Animation container found:', animationContainer);
            animationContainer.innerHTML = '';

            try {
                const anim = lottie.loadAnimation({
                    container: animationContainer,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: 'assets/animations/confetti.json',
                });

                anim.addEventListener('DOMLoaded', () => {
                    console.log('Animation loaded successfully');
                });

                anim.addEventListener('error', error => {
                    console.error('Animation error:', error);
                });
            } catch (error) {
                console.error('Error initializing animation:', error);
            }
        } else {
            console.error('Animation container not found');
        }
    }
}
